const commentTypes = {
  DiscusionDeEvaluaciones: 1,
  ManejoCitas: 2,
  ReferidosParteCAParteB: 3,
  RegistroEstudiantesImpedimentosVisuales: 4,
  Disciplina: 165,
  Egreso: 166,
  EgresoEliminarEgreso: 351,
  Elegibilidad: 168,
  Estudiante: 164,
  EvaluaciónInicial: 295,
  Inactivación: 399,
  Libros: 170,
  Maestro: 169,
  PEI: 163,
  Registro: 167,
  RegistroComentarioInactividad: 225,
  RegistroReactivacion: 375,
  RegistroSeguimiento: 321,
  Traslado: 277,
  TransportacionBecas: 365,
  CrearModificarPEI: 500,
  CumplimientoServiciosEstudianteRLV: 501,
  ManejoConsultaUbicacionEstudiante: 502,
  ManejoReferidos: 503,
  ReferidosAsistenciaTecnologica: 504,
  SolicitudHorasCompensatorias: 505,
  EstudianteNoElegible: 1496,
  EstudiantePreRegistro: 1497,
  EstudianteRegistro: 1498,
  EstudianteEvaluado: 1499,
  EstudianteDisponible: 1500,
  EstudianteInactivo: 1501,
  PeiCancellationReason: 1502
};

export default commentTypes;
